import React from 'react';
import styled from 'styled-components';
import { CreateFormTheme } from '../../../utils/themes';
import StyledText from '../../StyledComponents/StyledText';
import { useTheme } from '../../../middleware/ThemeContext';

const ChipContainer = styled('div')<{ $isDragging?: boolean }>(({ theme, $isDragging }) => ({
  padding: '10px 10px',
  width: 'fit-content',
  display: 'flex',
  background: theme.CreateFormTheme.colors.headerBG,
  color: theme.CreateFormTheme.colors.headerColor,
  border: $isDragging ? '1px dashed #003366' : '1px solid #ccc',
  borderRadius: '6px',
  cursor: 'grab',
  boxShadow: $isDragging ? '0 0 8px rgba(0, 123, 255, 0.4)' : 'none',
}));

interface FieldChipProps {
    icon: React.ReactNode;
    label: string;
    isDragging?: boolean;
    onDragStart: (e: React.DragEvent<HTMLDivElement>) => void;
    onDragEnd: () => void;
}

export const FieldChip: React.FC<FieldChipProps> = ({
    icon,
    label,
    isDragging = false,
    onDragStart,
    onDragEnd
}) => {
    const { theme } = useTheme();
    return (
        <ChipContainer
            theme={theme}
            $isDragging={isDragging}
            draggable
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
        >
            {icon}
            <StyledText className='ms-2 ml-2' fontSize='13px' fontWeight={500} color={theme.CreateFormTheme.colors.headerColor}>
                {label}
            </StyledText>
        </ChipContainer>
    );
};